import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from './cn.js';
// Status variants use a tinted fill (bg-*/12) + token text so the small label
// clears AA; primary is solid (warm-ink on orange is AA, orange text is not).
const VARIANT_CLASSES = {
    default: 'bg-secondary text-secondary-foreground',
    primary: 'bg-primary text-primary-foreground',
    success: 'bg-success/12 text-success',
    warning: 'bg-warning/12 text-warning',
    danger: 'bg-destructive/12 text-destructive',
    info: 'bg-info/12 text-info',
    outline: 'border border-border text-foreground',
};
/** Small status/label chip. Inline; carries its own text color contrast. */
export const Badge = forwardRef(({ className, variant = 'default', ...props }, ref) => (_jsx("span", { ref: ref, className: cn('inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-2xs font-semibold', VARIANT_CLASSES[variant], className), ...props })));
Badge.displayName = 'Badge';
